// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"607":"a749ced2","632":"70000c63"}[chunkId] + ".css";
};